const frontend = [
  {
    technology: 'Next.js',
  },
  {
    technology: 'ReactJS',
  },
  {
    technology: 'TypeScript',
  },
  {
    technology: 'JavaScript',
  },
  {
    technology: 'TailwindCSS',
  },
];

export default frontend;
